module.exports = __webpack_public_path__ + "static/media/christian-dior-spring-2017-jadior-flap-bag.b950992b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/christian-dior-spring-2017-jadior-flap-bag.png
// module id = 229
// module chunks = 0